import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import ImageLoader from 'react-render-image';
import { Icon, Shimmer } from '../Icon';
import { IconEmptyWrapper, IconPositionWrapper, IconTitleWrapper, IconWrapper, TitleWrapper, EmojiWrapper, TitleWrapperClassName } from './styled';
import LinkIcon from '@atlaskit/icon/glyph/link';
import { LinkAppearance, NoLinkAppearance } from '../styled';
export class IconAndTitleLayout extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleClick", event => {
      const {
        onClick
      } = this.props;
      if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    });
    _defineProperty(this, "handleKeyPress", event => {
      const {
        onClick
      } = this.props;
      if (event.key !== ' ' && event.key !== 'Enter') {
        return;
      }
      if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    });
  }
  renderAtlaskitIcon() {
    const {
      icon,
      emoji
    } = this.props;
    if (emoji) {
      return /*#__PURE__*/React.createElement(EmojiWrapper, null, emoji);
    }
    if (!icon || typeof icon === 'string') {
      return null;
    }
    return /*#__PURE__*/React.createElement(IconWrapper, null, icon);
  }
  renderImageIcon(errored, testId) {
    const {
      icon: url
    } = this.props;
    if (!url || typeof url !== 'string') {
      return null;
    }
    return /*#__PURE__*/React.createElement(ImageLoader, {
      src: url,
      loaded: /*#__PURE__*/React.createElement(Icon
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      , {
        className: "smart-link-icon",
        src: url,
        "data-testid": `${testId}-image`
      }),
      errored: errored,
      loading: /*#__PURE__*/React.createElement(Shimmer, {
        testId: `${testId}-loading`
      })
    });
  }
  renderIconPlaceholder(testId) {
    const {
      defaultIcon
    } = this.props;
    if (defaultIcon) {
      return /*#__PURE__*/React.createElement(IconWrapper, null, defaultIcon);
    }
    return /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(LinkIcon, {
      label: "link",
      size: "small",
      testId: `${testId}-default`
    }));
  }
  renderIcon(testId) {
    // We render two kinds of icons here:
    // - Image: acquired from either DAC or Teamwork Platform Apps;
    // - Atlaskit Icon: an Atlaskit SVG;
    // Each of these are scaled down to 12x12.
    const icon = this.renderAtlaskitIcon();
    if (icon) {
      return icon;
    }
    const placeholder = this.renderIconPlaceholder(testId);
    const image = this.renderImageIcon(placeholder, testId);
    return image || placeholder;
  }
  render() {
    const {
      children,
      title,
      titleColor,
      titleTextColor,
      link,
      rightSide,
      testId = 'inline-card-icon-and-title'
    } = this.props;
    const titlePart = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconPositionWrapper, null, children || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconEmptyWrapper, null), this.renderIcon(testId))), /*#__PURE__*/React.createElement(TitleWrapper
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
      style: {
        color: titleTextColor
      }
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: TitleWrapperClassName
    }, title));
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      React.createElement(IconTitleWrapper, {
        style: {
          color: titleColor
        },
        "data-testid": testId
      }, link ? /*#__PURE__*/React.createElement(LinkAppearance, {
        href: link,
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress
      }, titlePart) : titlePart, rightSide ? /*#__PURE__*/React.createElement(NoLinkAppearance, null, rightSide) : null)
    );
  }
}
_defineProperty(IconAndTitleLayout, "defaultProps", {
  rightSideSpacer: true
});